import {Component, Inject, OnInit} from '@angular/core';
import {CompetitionWz} from "../../../shared/interface/competition-wz";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface CompetitionImportValuesDialogData {
  competitionWz?: CompetitionWz;
}

@Component({
  selector: 'app-competition-import-values-dialog-list',
  templateUrl: './competition-import-values-dialog-list.component.html',
  styleUrls: ['./competition-import-values-dialog-list.component.scss']
})
export class CompetitionImportValuesDialogListComponent implements OnInit {
  competitionWzObject?: CompetitionWz = null;

  constructor(
    public dialogRef: MatDialogRef<CompetitionImportValuesDialogListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CompetitionImportValuesDialogData
  ) {
    this.competitionWzObject = data.competitionWz;
  }
  ngOnInit(): void {
  }

}
